<template>
  <div class="checkbox-group w-100">
    <TextLabel
      v-if="label"
      class="d-flex justify-content-between mb-3"
      :variant="errors.first(name) ? 'error' : 'secondary'"
      :required="required"
    >
    </TextLabel>
    <div class="checkbox-group_items-wrapper" :class="`checkbox-group_${mode}`">
      <label
        v-for="(item, index) in variants"
        :key="index"
        class="cursor-pointer checkbox-group_item"
        v-bind="item.title ? { title: item.title } : null"
      >
        <div class="game">
          <input
            :id="`${name}_${item.value}`"
            v-model="valueModel"
            type="checkbox"
            :name="name"
            class="checkbox-group_input"
            :value="item.value"
          />

          <span
            class="checkbox-group_border"
            :class="{ 'shape-mask': mode === 'rounded' }"
          ></span>

          <AppIcon v-if="hasCheckbox" name="check-on" :width="18" original />
          <Avatar
            v-if="mode === 'rounded'"
            v-bind="{
              imgUrl: item.img,
              size: imgSize,
              type: imgType,
              ...avatarProps,
            }"
          />
          <img v-else class="main-img" :src="item.img" />
          <span class="game-title">
            <span v-if="item.title" class="mt-1 mb-2 checkbox-group_title"
              >{{ item.title }}
            </span>
          </span>
          <!-- <div class="star-container"> -->
          <img
            src="@/assets/images/auth/star.svg"
            alt="Star icon"
            class="star-icon"
          />
          <img
            src="@/assets/images/auth/starFill.svg"
            alt="star icon"
            class="star-icon-fill"
          />
          <!-- </div> -->
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import { prop, propRequired } from '@/utils/factories';
import TextLabel from '@/components/atoms/TextLabel';
import Avatar from '@/components/images/Avatar';
import AppIcon from '@/components/atoms/Icon';

export default {
  name: 'ImageCheckboxGroup',
  components: {
    AppIcon,
    TextLabel,
    Avatar,
  },
  inject: ['$validator'],

  props: {
    value: prop(Array),
    variants: propRequired(Array),
    name: propRequired(String),
    label: prop(String),
    imgSize: prop(Number, 40), // use avatarProps
    imgType: prop(String), // use avatarProps
    avatarProps: prop(Object, null),
    withoutCheckAll: prop(Boolean),
    hasCheckbox: prop(Boolean),
    required: prop(Boolean),
    mode: prop(String, 'rounded'), // rounded, card
  },
  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },

    isAllChecked() {
      const checked = this.$lodash.get(this, 'value.length');
      const total = this.$lodash.get(this, 'variants.length');
      return checked === total;
    },
  },

  methods: {
    toggleCheckAll() {
      if (this.isAllChecked) {
        this.$emit('input', []);
      } else {
        this.$emit('input', this.variants.map(({ value }) => value));
      }
    },
  },
};
</script>

<style lang="scss">
.main-img {
  width: 3rem;
  height: 3rem;
  border-radius: 5px;
  justify-content: center;
  margin-top: 1rem;
  align-items: center;
}

.checkbox-group_item {
  background: $new-bg-primary-faded-second;
  border-radius: 5px;
  display: flex;
}

.game {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.game-title {
  font-weight: 700;
  width: 45%;
  display: flex;
  text-align: left;
  margin-right: 1.5rem;
  padding-left: 10px;
  flex-wrap: wrap;
  white-space: wrap;
}

.checkbox-group_title {
  height: 100%;
  display: flex;
  align-items: center;
}

.star-icon {
  width: 32px !important;
  height: 32px !important;
  border: 1px solid $hr-text-secondary;
  padding: 3px;
}

.star-icon-fill {
  width: 32px !important;
  height: 32px !important;
  border: 1px solid $hr-text-secondary;
  padding: 5px;
}

.star-container {
  border: 1px solid $hr-text-secondary;
  height: 2rem;
  align-items: center;
  padding: 3px;
  border-radius: 5px;
}

body.dark-theme {
  background-color: $hr-bg-main;
}

$checkbox-border-width: 0.125rem;
.checkbox-group {
  --items-space: 0.75rem;
  &_items-wrapper {
  }
  &_item {
    padding: 0 calc(var(--items-space) / 2);
  }
  &_input {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
  }
  &_input:checked + &_border {
    opacity: 1;
    + .svg-icon-wrapper {
      opacity: 1;
    }
  }
  .svg-icon-wrapper {
    position: absolute;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
  }
  &_border {
    position: absolute;
    top: -$checkbox-border-width;
    right: -$checkbox-border-width;
    left: -$checkbox-border-width;
    @include primary-background-gradient(230deg);
    opacity: 0;
    transition: opacity 0.3s;
  }

  &_rounded {
    --items-space: 0.75rem;
    .checkbox-group_border {
      padding-top: calc(100% - #{$checkbox-border-width * 4});
    }
    .svg-icon-wrapper {
      @include auto-rtl(right, 2 * $checkbox-border-width);
      padding-top: 100%;
      margin-top: calc(
        #{-$checkbox-border-width} - 18px - #{$checkbox-border-width * 4}
      );
    }
  }

  &_card {
    $checkbox-border-width: 1px;

    --items-space: 1.5rem;
    input {
      opacity: 0;
    }
    img {
      width: 7rem;
      height: 9rem;
      object-fit: cover;
      position: relative;
      border-radius: $ph-small-radius;
    }
    .checkbox-group_border {
      margin: 0 calc(var(--items-space) / 2);
      width: calc(7rem + #{$checkbox-border-width * 2});
      height: calc(9rem + #{$checkbox-border-width * 2});
      transform: translate($checkbox-border-width, $checkbox-border-width);
      border-radius: $ph-small-radius;
    }

    .svg-icon-wrapper {
      @include auto-rtl(right);
      top: 9rem;
      transform: translate(-#{$checkbox-border-width * 2}, -50%);
    }
  }
}

.checkbox-group {
  max-width: 80vw;
}
</style>
